import { Sparkles } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { AppCard } from "@/components/apps/AppCard";
import { NoveltyBanner } from "@/components/apps/NoveltyBanner";

// Home, official section: the most recent official addition still in its « Nouveauté » window.
export const LatestAddition = ({ apps }) => {
  const { t } = useI18n();
  const latest = (apps || []).filter((a) => a.novelty && !a.developer).sort((a, b) => b.novelty.since.localeCompare(a.novelty.since))[0];
  // a lone mini-site is already featured (with its banner) in the mini-sites section just below
  if (!latest || (latest.category === "minisite" && apps.filter((a) => a.category === "minisite").length === 1)) return null;
  return (
    <div className="mb-10 min-w-0" data-testid="home-latest-addition">
      <p className="mb-3 flex items-center gap-2 font-display text-[0.7rem] uppercase tracking-[0.3em] text-[var(--red-bright)]"><Sparkles className="h-4 w-4" /> {t("novelty.latest")}</p>
      <div className="max-w-xl min-w-0 space-y-2">
        <NoveltyBanner app={latest} teaser testId="home-latest-banner" />
        <AppCard app={latest} hideNovelty />
      </div>
    </div>
  );
};
